declare var $: any; //Need this to use JQuery
import Swal from 'sweetalert2'
import { Component, OnInit, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { Product } from 'src/app/avantoeats-util/models/menu/Product';
import { ScrollFunctions } from '../../../util/ScrollFunctions';
import { KeyValue } from '@angular/common';
import { Customization } from 'src/app/avantoeats-util/models/menu/Customization';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { Subscription } from 'rxjs';
import { AvantoRestaurantsService } from 'src/app/services/avanto-restaurants.service';
import { SessionObject } from 'src/app/avantoeats-util/models/session/SessionObject';
import { CartItem } from 'src/app/avantoeats-util/models/cart/CartItem';
import { AvantoModalControlService } from 'src/app/services/avanto-modalControl.service';
import { CustomizationContainerComponent } from './customization-container/customization-container.component';
import { AvantoAlert } from 'src/app/util/Alerts';

@Component({
  selector: 'app-product-customization-modal',
  templateUrl: './product-customization-modal.component.html',
  styleUrls: ['./product-customization-modal.component.scss']
})
export class ProductCustomizationModalComponent implements OnInit, OnDestroy {

  @ViewChildren(CustomizationContainerComponent) customizations: QueryList<CustomizationContainerComponent>

  readonly MODAL_ID = "productCustomizationModal";
  private _selectedProduct: Product;
  get selectedProduct() { return this._selectedProduct }

  private sessionObserver: Subscription = new Subscription();
  private menuEditRequestsObserver: Subscription = new Subscription();
  private restaurantAvailabilitySubscription: Subscription = new Subscription();

  isDelivery: boolean;
  isASAP: boolean;
  selectedProductQuantity: number;
  additionalNotes: string;
  calculatedTotal: number;
  isAddingItemToCart: boolean
  restaurantIdInsideSession: string;
  numberOfItemsInsideOfCart: number;
  selectedCustomizationItems: Map<string, SelectedCustomization>;
  customizationEditSelection: Map<string, SelectedCustomization>;
  displayCustomizationsMap:Map<string,Map<string,string[]>>;
  displayedCustomizations:any = {}
  editedCartId: string;

  isRestaurantAvailablePickup: boolean;
  restaurantPickupUnavailableMsg: string;
  isRestaurantAvailableDelivery: boolean;
  restaurantDeliveryUnavailableMsg: string;
  showAddMultipleItemsOption:boolean;

  oneRestaurantModePickupOnly: boolean;

  selectedRestaurantId: string;
  initializedProductId:string;

  constructor(private avantoSession: AvantoSessionService, private avantoRestaurantsService: AvantoRestaurantsService, private avantoModal: AvantoModalControlService) { }
  ngOnInit() {
    //Initializing with an empty object, so I dont get error messages
    this._selectedProduct = {} as Product;
    this.selectedProductQuantity = 1;
    this.showAddMultipleItemsOption = true;
    this.selectedCustomizationItems = new Map();
    this.customizationEditSelection = new Map();
    this.displayCustomizationsMap = new Map();
    this.displayedCustomizations = {};
    this.isRestaurantAvailablePickup = false
    this.isRestaurantAvailableDelivery = false
    this.isDelivery = false;
    this.isAddingItemToCart = false;
    this.oneRestaurantModePickupOnly = false;

    //Watches the session to determine if the user selected delivery or not
    this.sessionObserver = this.avantoSession.sessionSubject.subscribe(session => {
      this.isDelivery = session.orderType == SessionObject.ORDER_TYPE_DELIVERY;
      this.isASAP = session.orderDate == SessionObject.DELIVERY_TIME_ASAP;
      this.restaurantIdInsideSession = session.restaurantInformation.restaurantId;
      this.numberOfItemsInsideOfCart = session.cart.cartItems.size;
      this.oneRestaurantModePickupOnly = (session.isOneRestaurantMode && session.restaurantInformation.hasPickup && !session.restaurantInformation.hasDelivery);
    });
    //Watches the restaurant availability message for changes
    this.restaurantAvailabilitySubscription = this.avantoRestaurantsService.subject_restaurantAvailability.subscribe(results => {
      const availability = results.entries().next().value[1];
      this.isRestaurantAvailablePickup = availability.pickupAvailability.isOpen;
      this.restaurantPickupUnavailableMsg = availability.pickupAvailability.message;
      this.isRestaurantAvailableDelivery = availability.deliveryAvailability.isOpen;
      this.restaurantDeliveryUnavailableMsg = availability.deliveryAvailability.message
    })
    //Watches the cart, waiting for the user to request that one of it's items be edited
    this.menuEditRequestsObserver = this.avantoRestaurantsService.subject_cartItem_add_edit_request.subscribe((response: { product: Product, restaurantId: string, cartItem?: CartItem }) => {
      this.initialize(response.product, response.restaurantId, response.cartItem)
    })
  }

  ngOnDestroy() {
    this.restaurantAvailabilitySubscription.unsubscribe();
    this.menuEditRequestsObserver.unsubscribe();
    this.sessionObserver.unsubscribe();
  }

  /** Resets the fields of this modal and then opens it */
  initialize(product: Product, restaurantId: string, editedCartItem?: CartItem) {
    if (this.restaurantIdInsideSession != null && this.restaurantIdInsideSession != restaurantId && this.numberOfItemsInsideOfCart > 0) {
      Swal.fire({
        title: 'Your cart already has items from another restaurant',
        text: "Adding products from a different restaurant will cause the cart to be cleared. Are you sure you want to clear the cart?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1b9637',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, clear the cart!'
      }).then((result) => {
        if (result.value) {
          this.finishInitialization(product, restaurantId, editedCartItem);
        }
      })
    } else {
      this.finishInitialization(product, restaurantId, editedCartItem);
    }
  }

  finishInitialization(product: Product, restaurantId: string, editedCartItem?: CartItem) {
    this._selectedProduct = product;
    this.selectedRestaurantId = restaurantId;
    this.selectedCustomizationItems.clear()
    this.customizationEditSelection.clear()
    this.displayCustomizationsMap.clear();
    this.displayedCustomizations = {};
    this.showAddMultipleItemsOption = product.allowQttyEdit;

    this.selectedProduct.customizations.forEach((c,cId)=>{
      if(c.dependeeItems!=null && c.dependeeItems.length>0){
        //We use 2 things to determine dependees - the map and the object (EXPLAIN)

        const customizationDependanceMap = new Map();
        c.dependeeItems.forEach(dependance=>{

          //Sets the displayedCustomizations with false. This object is used on the NgIf condition............. EXPLAIN
          this.displayedCustomizations[cId+"."+dependance.title] = false;

          //Sets the map
          dependance.customizationItemIds.forEach(customItemId=>{
            let dependeeTitles:string[];
            if(customizationDependanceMap.has(customItemId)){
              dependeeTitles = customizationDependanceMap.get(customItemId);
            }else{
              dependeeTitles = [];
            }
            
            if(!dependeeTitles.includes(dependance.title)){
              dependeeTitles.push(dependance.title);
              customizationDependanceMap.set(customItemId,dependeeTitles);
            }
            
          })
        })
        this.displayCustomizationsMap.set(cId, customizationDependanceMap);
      }
    })

    this.editedCartId = null;

    this.isAddingItemToCart = false;
    this.additionalNotes = "";

    if (editedCartItem != null) {
      //Is editing
      this.selectedProductQuantity = editedCartItem.quantity;
      this.calculatedTotal = editedCartItem.price;

      editedCartItem.customizations.forEach((custom) => {
        this.customizationEditSelection.set(custom.customizationId, new SelectedCustomization(custom.selectedOptions, true));
      })
      this.editedCartId = editedCartItem.cartItemId;
      if(editedCartItem.note!=null){
        this.additionalNotes = editedCartItem.note;
      }
    } else {
      //Not editing
      this.selectedProductQuantity = 1;
      this.calculatedTotal = this.selectedProduct.price;
    }

    //Since this component is inside a modal, it wont be destroyed once you close it. The modal is still there on the background.
    //That means that if I open the modal with the same product again, the items that you selected when you edited this component last time will still be there...
    //So I need to re-calculate the totals...
    const selectedProductId = product.getIdString();
    if(this.initializedProductId == selectedProductId){
      this.customizations.forEach(childComponent=>{
        childComponent.updateSelectedItems();
      })
    }
    this.initializedProductId = selectedProductId;

    this.calculatePrice();
    $("#" + this.MODAL_ID).modal();
  }

  tryAnotherTimeOrType(){
    if (this.oneRestaurantModePickupOnly) {
      this.avantoModal.openOrderDetailsModal(false, true, true);
    } else {
      this.avantoModal.openOrderDetailsModal(true, true, true);
    }
  }

  /** Used to sort the customizations of a product based on their displayOrder attribute  */
  productCustomizationSorter = (akv: KeyValue<string, Customization>, bkv: KeyValue<string, Customization>): number => {
    const a = akv.value.displayOrder;
    const b = bkv.value.displayOrder;

    return a > b ? 1 : (b > a ? -1 : 0);
  };

  /** Called when the user changes the quantity of the product */
  productQttyChanged(newValue) {
    this.selectedProductQuantity = newValue;
    this.calculatePrice();
  }

  /**
   * The customer changed one of the customization options. The customerSelection object must be updated accordingly.
   * THIS FUNCTION IS CALLED ONCE FOR EVERY CUSTOMIZATION when you initialize the "app-customization-container" for the customization.
   * @param customizationId ID of the customization
   * @param selectedOptions What customization options were selected (their IDs) and how many of them
   */
  customizationSelectionChanged(customizationId, selectedOptions: { optionId: string, quantity: number, itemMultiplier:number, toppingSide:"left"|"full"|"right"|null }[]) {
    const selectedProdCustomization = this.selectedProduct.customizations.get(customizationId);

    const customizationSelection = new SelectedCustomization(
      selectedOptions,
      selectedProdCustomization.isValidSelection(selectedOptions)
    );

    this.selectedCustomizationItems.set(customizationId, customizationSelection)

    //Checks if the displayedCustomizationsMap (that contains the customizations that may not be displayed, due to something not being selected) has
    // this customization as a dependee
    if(this.displayCustomizationsMap.has(customizationId)){
      const dependencyItems = this.displayCustomizationsMap.get(customizationId);

      dependencyItems.forEach((dependencyTitles,_customizationItemId)=>{
        dependencyTitles.forEach(dt=>{
          const dependencyKey = customizationId+"."+dt;
          //If this is was set as true, it means that this customization was being displayed and will now be hidden - we need to un-select all the customizations under it
          if(this.displayedCustomizations[dependencyKey]!=null && this.displayedCustomizations[dependencyKey]){
            this.selectedProduct.customizations.forEach((c,cId)=>{
              if(c.dependsOn!=null && c.dependsOn==dependencyKey){
                this.selectedCustomizationItems.set(cId,new SelectedCustomization([],true))
              }
            })
          }
          this.displayedCustomizations[dependencyKey] = false;
        })
      })     

      selectedOptions.forEach(option=>{
        if(option.quantity>0 && dependencyItems.has(option.optionId)){
          dependencyItems.get(option.optionId).forEach(dt=>{
            this.displayedCustomizations[customizationId+"."+dt] = true;
          })
        }
      })

    }

    this.calculatePrice();
  }

  //============== Calculate Price ==============\\
  isCalculatingPrice: boolean = false;
  calculatePriceRequested: boolean = false;
  /** Calculates the total price for the added product. 
   * The boolean variables used here, "isCalculatingPrice" and "calculatePriceRequested" are used to 
   * in case the user tries to call this function more than once in a short period of time. We make sure
   * only one instance of this function is running at once. If you try to call it while it's already running, 
   * it will wait until the function finishes running until it can be called again... */
  calculatePrice() {
    //Function is NOT already running
    if (!this.isCalculatingPrice) {
      this.isCalculatingPrice = true;

      let selectedCustomizations: { customizationId: string, selectedOptions: { optionId: string, quantity: number, itemMultiplier:number, toppingSide:"left"|"full"|"right"|null }[] }[] = [];
      this.selectedCustomizationItems.forEach((c, cId) => {
        selectedCustomizations.push({
          customizationId: cId,
          selectedOptions: c.selectionOptions
        })
      });
      this.calculatedTotal = this.selectedProduct.calculateSelectedPrice(this.selectedProductQuantity, selectedCustomizations, this.isDelivery)

      //The function was called again while it was already running. We execute it again.
      if (this.calculatePriceRequested) {
        this.calculatePriceRequested = false;
        this.calculatePrice();
      } else {
        this.isCalculatingPrice = false;
      }
    } else {
      //The function is already running. We set this flag to true, so when the function ends running it will know
      //it needs to be run again
      this.calculatePriceRequested = true;
    }
  }
  //============== Calculate Price END ==============\\


  //============== Cart ==============\\
  addToCart() {
    this.isAddingItemToCart = true;

    //Goes through each customization and checks if its valid
    let customizationSelection: { customizationId: string, selectedOptions: { optionId: string, quantity: number, toppingSide: "left"|"right"|"full"|null }[] }[] = [];
    for (let key of Array.from(this.selectedCustomizationItems.keys())) {

      if (!this.selectedCustomizationItems.get(key).isValid) {
        //If the customization is NOT valid, scrolls up to it and exits the function
        ScrollFunctions.scrollToIdInModal(this.MODAL_ID, key, 45)
        AvantoAlert.toast("warning","Required customization needs to be selected.")

        this.isAddingItemToCart = false;
        return;
      } else {
        const selectedOptions = this.selectedCustomizationItems.get(key).selectionOptions;
        if (selectedOptions != null && selectedOptions.length > 0) {
          customizationSelection.push({
            customizationId: key,
            selectedOptions: selectedOptions
          })
        }
      }
    }

    this.avantoSession.setItemInSession(
      this.selectedProduct.id,
      this.selectedRestaurantId,
      this.selectedProductQuantity,
      this.selectedProduct.version,
      this.additionalNotes,
      customizationSelection, this.editedCartId)
      .then(() => {
        this.isAddingItemToCart = false;
        AvantoAlert.toast("success","Your product has been added.",'top-left')
        $("#" + this.MODAL_ID).modal('hide');
      })
      .catch(() => {
        console.error("Could not add product to cart, error communicating with the webservice")
        AvantoAlert.toast("error","Could not add item to cart. Please, check your connection and try again.")
        this.isAddingItemToCart = false;
      });

  }
  //============== Cart END ==============\\
}

export class SelectedCustomization {
  selectionOptions: { optionId: string, quantity: number, itemMultiplier:number, toppingSide:"left"|"full"|"right"|null }[];
  isValid: boolean;

  constructor(selected: { optionId: string, quantity: number, itemMultiplier:number, toppingSide:"left"|"full"|"right"|null }[], isValid: boolean) {
    this.selectionOptions = selected;
    this.isValid = isValid;
  }
}